





























import { Component, Vue, Prop } from 'vue-property-decorator';
import TabItem from './TabItem.vue';

@Component({
  components: {
    TabItem,
  },
})
export default class Tab extends Vue {
  @Prop(Array) tabs!: {
    label: string;
    to: string;
  }[];
}
